import styled from "styled-components";
import { eventControlsMargin } from "events/styles";

export const EventControlsWrapper = styled.div`
`;
